import React, { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setAuthTab, setPlatform } from "../Redux/Actions/AuthAction";
import { toast } from "react-toastify";
import FormatHelper from "../Helper/FormatHelper";
import axios from "axios";
import lang from "../Constant/lang.json";

export const AuthContext = createContext();

export const AuthProvider = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mobile = useSelector((state) => state.AuthReducer.userMobile);
  const [fcmToken, setFcmToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches) {
      dispatch(setPlatform("pwa"));
    } else {
      dispatch(setPlatform("web"));
    }
  }, []);

  // register to onesignal -------------------------------------------------------
  const registerToOnesignal = async (token) => {
    let postData = {
      register_data: {
        app_id: "43fa58d9-70b0-4434-b3ae-49494e92a84e",
        device_type: 1,
        device_model: navigator.userAgent,
        language: "en",
        identifier: fcmToken,
        tags: {
          role: "pro",
          mobile: mobile,
        },
      },
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1.0/register_to_onesignal`,
        postData,
        {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "app-type": "7",
          },
        }
      );
      if (response.status === 200) {
        console.log("Registered to Onesignal Successfully!");
      }
    } catch ({ err, response }) {
      toast.error(lang.API_500_ERROR_MESSAGE);
    }
  };

  const proLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + "/api/v1.0/pro_login",
        {
          mobile: FormatHelper.toEnglishString(mobile),
        },
        {
          headers: {
            "app-type": "7",
          },
        }
      );
      setLoading(false);
      if (response.data.status === true) {
        toast.success(response?.data?.message);
        dispatch(setAuthTab(1));
        if (response.data.otp) {
          setOtp(response.data.otp);
        }
      } else if (response.status === 200 && response.data.status === false) {
        toast.error(response?.data?.message);
      }
    } catch ({ err, response }) {
      toast.error(response?.data?.errors[0]?.detail);
      setLoading(false);
    }
  };

  const getToken = async (code) => {
    try {
      setLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + "/oauth/token",
        {
          username: FormatHelper.toEnglishString(mobile),
          password: FormatHelper.toEnglishString(code),
          grant_type: "password",
          client_id: "1",
          client_secret: "ozD5845g8CcHeVmbOf0GpTvmYcvlSY9uh82KItUM",
        },
        {
          headers: {
            "app-type": "7",
          },
        }
      );
      setLoading(false);
      if (response.status === 200) {
        toast.success(lang.LOGIN_SUCCESSFULLY);
        localStorage.setItem("token", response.data.access_token);
        localStorage.removeItem("auth_from_admin");
        if (fcmToken) {
          registerToOnesignal(response?.data?.access_token);
        }
        dispatch(setAuthTab(0));
        navigate("/techapp");
      }
    } catch ({ err, response }) {
      if (response?.status === 401) {
        toast.error(lang.INVALID_CONFIRM_CODE);
      } else {
        toast.error(response?.data?.message);
      }
      setLoading(false);
    }
  };

  const value = { proLogin, getToken, fcmToken, setFcmToken, loading, otp };
  return (
    <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
  );
};
